import { RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useToast } from '@/components/ui/toast'
import { requestErrorMessage } from '@/helpers/apiClient'
import { useRefreshAds } from '@/hooks/useAds'

interface RefreshAdsButtonProps {
  /** One venue's accounts, or all of the company's. */
  venueId?: string
  /** Something is importing already: refreshing would only be refused. */
  busy: boolean
}

/**
 * Reads Google again now (docs/ad-analytics.spec.md, "Importing"): late
 * corrections, never today. While a read is running it says so instead.
 */
export function RefreshAdsButton({ venueId, busy }: RefreshAdsButtonProps) {
  const refresh = useRefreshAds()
  const { toast } = useToast()
  const running = busy || refresh.isPending

  function start() {
    refresh.mutate(venueId === undefined ? {} : { venueId }, {
      onError: (e) => toast(requestErrorMessage(e), { variant: 'error' }),
    })
  }

  return (
    <Button variant="ghost" size="sm" onClick={start} disabled={running}>
      <RefreshCw className={running ? 'h-3.5 w-3.5 motion-safe:animate-spin' : 'h-3.5 w-3.5'} />
      {running ? 'Updating…' : 'Refresh'}
    </Button>
  )
}
